export interface DocumentRevision {
	date: string;
	changes: string;
	filePath: string;
}

export interface Document {
	id: string;
	nameKey: string;
	descriptionKey: string;
	currentRevision: DocumentRevision;
	revisions: DocumentRevision[];
}

export type DocumentType = "termsOfService" | "privacyPolicy";

const termsOfServiceRevisions: DocumentRevision[] = [
	{
		date: "2025-04-22",
		changes: "Uppdaterade SaaS allmänna villkor",
		filePath: "/documents/terms-of-service/Exopen -  SaaS GTC 250422.pdf",
	},
	{
		date: "2022-02-14",
		changes: "Första versionen av SaaS allmänna villkor",
		filePath: "/documents/terms-of-service/Exopen -  SaaS GTC 220214.pdf",
	},
];

const privacyPolicyRevisions: DocumentRevision[] = [
	{
		date: "2025-03-01",
		changes: "Exopen Data Processing Agreement",
		filePath:
			"/documents/privacy-policy/Exopen -  Data Processing Agreement 250301.pdf",
	},
];

export const documents: Record<DocumentType, Document> = {
	termsOfService: {
		id: "termsOfService",
		nameKey: "SaaS General Terms and Conditions",
		descriptionKey:
			"General terms and conditions for using Exopen SaaS services",
		currentRevision: termsOfServiceRevisions[0],
		revisions: termsOfServiceRevisions,
	},
	privacyPolicy: {
		id: "privacyPolicy",
		nameKey: "Data Processing Agreement",
		descriptionKey:
			"Agreement regarding processing and protection of personal data",
		currentRevision: privacyPolicyRevisions[0],
		revisions: privacyPolicyRevisions,
	},
};

export const getDocument = (type: DocumentType): Document => {
	return documents[type];
};

export const getAllDocuments = (): Document[] => {
	return Object.values(documents);
};
